<main class="container">
  <section class="col-8 mx-auto text-center">
    <header>
      <!--Since it's only for ux-->
      <h1>lesson.completeHeadline</h1>
      <p class="lead">lesson.completeCopy</p>
    </header>

    <div class="jumbotron">
      <div class="row">
        <div class="col-6">
          <h3 class="display-3">75%</h3>
          <h4>
            Accuracy<br>
            <i class="fa fa-bullseye"></i>
          </h4>
        </div>
        <div class="col-6">
          <h3 class="display-3">##:##</h3>
          <h4>
            Per Question<br>
            <i class="fa fa-stopwatch"></i>
          </h4>
        </div>
      </div>
    </div>

    <div class="col-8 mx-auto">
      <h3><i class="fa fa-life-saver"></i> Smartsavers Earned</h3>
      <div class="lesson-smartsavers">
        <button class="btn btn-primary btn-sm">
          Pause
          <span class="badge badge-pill badge-light">#</span>
        </button>

        <button class="btn btn-primary btn-sm"
                [attr.aria-expanded]="!hintCollapsed"
                aria-controls="problemHint">
          Hint
          <span class="badge badge-pill badge-light">#</span>
        </button>

        <button class="btn btn-primary btn-sm">
          50/50
          <span class="badge badge-pill badge-light">#</span>
        </button>

        <button class="btn btn-primary btn-sm">
          Skip
          <span class="badge badge-pill badge-light">#</span>
        </button>
      </div>
    </div>

    <a class="btn btn-primary btn-lg mt-5" [routerLink]="['/../../../']">Return To Dashboard</a>
  </section>
</main>
